import { createSelector, createSlice } from '@reduxjs/toolkit';
export const initialAuthErrorState = {
    source: null,
    code: null,
    message: null,
};
export const authErrorSlice = createSlice({
    name: 'authError',
    initialState: initialAuthErrorState,
    reducers: {
        setAuthError: (state, action) => {
            state.code = action.payload.code;
            state.source = action.payload.source;
            state.message = action.payload.message || null;
        },
        clearAuthError: (state) => {
            state.code = null;
            state.source = null;
            state.message = null;
        },
    },
});
const authErrorState = (state) => state.core.authError;
export const authErrorSelector = createSelector(authErrorState, ({ source, code, message }) => {
    return {
        ...(source && { source }),
        ...(code && { code }),
        ...(message && { message }),
    };
});
export const { setAuthError, clearAuthError } = authErrorSlice.actions;
export default authErrorSlice.reducer;
//# sourceMappingURL=authErrorSlice.js.map